import { Mail, Phone, Facebook, Instagram } from "lucide-react";
import { CONTACT, SOCIALS } from "@/data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#efe4d1] border-t border-[#b8965a]/30 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16">
          <div className="lg:col-span-6">
            <img
              data-testid="footer-logo"
              src="/logo.png"
              alt="Roam Around UAE"
              className="w-[260px] max-w-full h-auto -ml-2 mix-blend-multiply"
            />
            <p className="font-serif-lux italic text-xl text-[#47564d] mt-2 max-w-md">
              Your UAE holiday, designed only for you.
            </p>

            <div className="flex items-center gap-4 mt-8">
              <a
                data-testid="footer-facebook-link"
                href={SOCIALS.facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="flex items-center justify-center w-11 h-11 border border-[#b8965a]/40 text-[#1f3a2e] hover:bg-[#b8965a] hover:text-[#fdfbf7] hover:border-[#b8965a] transition-colors duration-300"
              >
                <Facebook size={19} strokeWidth={1.4} />
              </a>
              <a
                data-testid="footer-instagram-link"
                href={SOCIALS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="flex items-center justify-center w-11 h-11 border border-[#b8965a]/40 text-[#1f3a2e] hover:bg-[#b8965a] hover:text-[#fdfbf7] hover:border-[#b8965a] transition-colors duration-300"
              >
                <Instagram size={19} strokeWidth={1.4} />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="font-body-lux text-xs uppercase tracking-[0.25em] text-[#9c7d44] mb-5">
              Get in Touch
            </p>
            <a
              data-testid="footer-email-link"
              href={`mailto:${CONTACT.email}`}
              className="flex items-center gap-3 font-body-lux text-[#1f3a2e] hover:text-[#9c7d44] transition-colors duration-300 mb-4"
            >
              <Mail size={18} strokeWidth={1.3} />
              {CONTACT.email}
            </a>
            <a
              data-testid="footer-phone-link"
              href={`tel:${CONTACT.phone}`}
              className="flex items-center gap-3 font-body-lux text-[#1f3a2e] hover:text-[#9c7d44] transition-colors duration-300"
            >
              <Phone size={18} strokeWidth={1.3} />
              {CONTACT.phoneDisplay}
            </a>
          </div>

          <div className="lg:col-span-3">
            <p className="font-body-lux text-xs uppercase tracking-[0.25em] text-[#9c7d44] mb-5">
              Explore
            </p>
            <div className="flex flex-col gap-3">
              {[
                { label: "The Idea", href: "#about" },
                { label: "Why Us", href: "#difference" },
                { label: "Experiences", href: "#experiences" },
                { label: "Book Consultation", href: "#contact" },
              ].map((l) => (
                <button
                  key={l.href}
                  data-testid={`footer-nav-${l.href.replace("#", "")}`}
                  onClick={() =>
                    document.querySelector(l.href)?.scrollIntoView({ behavior: "smooth" })
                  }
                  className="font-body-lux text-sm text-[#47564d] hover:text-[#1f3a2e] transition-colors duration-300 text-left"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-[#b8965a]/25 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body-lux text-xs text-[#6b7a70] tracking-wide">
            © {new Date().getFullYear()} Roam Around UAE. All rights reserved.
          </p>
          <p className="font-body-lux text-xs text-[#6b7a70] tracking-wide">
            Travel Designer — Not a Package Seller
          </p>
        </div>
      </div>
    </footer>
  );
};
